import { ActionPointInfo, Controller, IActionPointInfo, Menu, Toolbar } from '@tencent/workbench';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { InsertLatexFeature } from './insert-latex-feature';
import { TOOLBAR_ITEMS, MENU_ITESMS, config } from './config';
import { wrapIdForBig } from '@src/framework/workbench/util/wrap-id-util';

@Controller({
    menuItems: MENU_ITESMS,
    toolbarItems: TOOLBAR_ITEMS,
})
export class InsertLatexController {
    constructor(private readonly feature: InsertLatexFeature) {
    }

    @Menu(config.id, 'shouldHide')
    @Toolbar(config.id, 'shouldHide')
    public shouldHide() {
        return !DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.insertLatex);
    }

    @Menu(config.id, 'shouldDisabled')
    @Toolbar(config.id, 'shouldDisabled')
    @Toolbar(wrapIdForBig(config.id), 'shouldDisabled')
    public shouldDisabled(@ActionPointInfo() info: IActionPointInfo) {
        return this.feature.shouldDisabled(config.id);
    }

    @Menu(config.id, 'onClick')
    @Toolbar(config.id, 'onClick')
    @Toolbar(wrapIdForBig(config.id), 'onClick')
    public onClick() {
        this.feature.onClick();
    }

    @Menu(config.id, 'content')
    @Toolbar(config.id, 'tooltip')
    @Toolbar(config.id, 'text')
    public getMenuContent() {
        return this.feature.getContent();
    }
}
